<div class="flex w-full h-full">
    <app-sidenav></app-sidenav>
    <div class="w-full overflow-hidden">
        <app-header></app-header>
        <router-outlet />
    </div>
</div>

<app-error-dialog [(isShowDialog)]="idleTimeDialogVisible" dialogId="dialogContinueSession" [title]="sessionDialogTitle" [content]="sessionDialogContent" [btnName]="btnName" [cancelBttnText]="cancelBttnText" [dialogHeader]="sessionDialogHeader" (onSuccess)="extendSession()" [closable]="false" (onCancel)="signOut()"></app-error-dialog>
<p-toast 
    position="bottom-left" 
    key="global-toast">
        <ng-template let-message pTemplate="message">
            <span [ngClass]="['p-toast-message-icon', 'pi', message.icon || 'pi-info']"></span>
                <div class="p-toast-message-text">
                <div class="p-toast-summary">{{ message.summary }}</div>
                @if(message.detail){
                     <div class="p-toast-detail">
                    {{ message.detail }}
                    @if(message.data.navText){
                        <span class="!text-body underline !cursor-pointer" (click)="gotoNavigate(message.data.navLink, message.data.isExternal)">{{ message.data.navText }}</span>
                    }
                </div>
                }
               
            </div>
        </ng-template>
</p-toast>
<!-- Connie -->
@if (isAiChatEnabled()) {
    <div class="fixed bottom-20 right-0 z-10">
        <div class="flex gs-chat-btn cursor-pointer" (click)="aiChatVisible.set(true)">
            <svg-icon class="icon-24 mb-1 ml-1" src="/assets/icons/chat.svg"></svg-icon>
        </div>
    </div>
    <app-ai-chat [(visible)]="aiChatVisible"></app-ai-chat>
}
